export const SpinnerStyle = {
  // Styles for the base style
  baseStyle: {
    color: 'blue.500'
  },
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {
    speed: '3s'
  }
}
